import React from 'react';
import { TCITooltip } from '@/components/ui/Tooltip';
import * as Routes from 'modules/routes';
import { AssessmentInfo } from './types';
import styles from './AssessmentRow/AssessmentRow.module.scss';
import CopyButton from './CopyButton';
import { sourceIsMyTests } from './utils';

interface EditButtonProps {
  assessment: AssessmentInfo;
  programId: string | number;
}

const EditButton = ({
  assessment, programId,
}: EditButtonProps) => {
  if (sourceIsMyTests(assessment.source)) {
    return (
      <TCITooltip>
        <TCITooltip.Trigger asChild>
          <a
            aria-label="Edit"
            className={styles.active}
            href={Routes.edit_staffer_assessment_path(assessment.id, { program_id: programId })}
          >
            <i aria-hidden="true" className="fa fa-pencil-square-o" />
          </a>
        </TCITooltip.Trigger>
        <TCITooltip.Content>Edit</TCITooltip.Content>
      </TCITooltip>
    );
  }

  return (
    <CopyButton
      assessment={assessment}
      iconClass="fa-clone"
      programId={programId}
    />
  );
};

export default EditButton;
